document.addEventListener('DOMContentLoaded', () => {
  const excludeListInputs = document.querySelectorAll('input[name="bad_team"]');
  const dataToOrderEl = document.getElementById('bad_teams');
  const openBtn = document.querySelector('.excluding__list__btn');
  const overlay = document.querySelector('.excluding__list__overlay');
  const popup = document.querySelector('.excluding__list');
  const savePopupBtn = document.querySelector('.apply__list__btn');
  const avoidClubs = document.querySelector('.clubs_colors-avoid');
  const avoidOrders = document.querySelector('.input-numeric');
  const closeList = document.querySelector('.close__list');

  let dataToOrder = [];
  let dataToShow = [];
  let lastClubs = '';
  let lastOrder = '';

  if (!openBtn || !overlay || !popup) return;
  document.body.appendChild(overlay);
  document.body.appendChild(popup);

  document.addEventListener('input', (event) => {
    const input = event.target.closest('.input-numeric');
    if (!input) return;
    input.value = input.value.replace(/\D/g, '');
  });
  const openPopup = () => {
    document.body.classList.add('excluding-list-open');
  };

  const closePopup = () => {
    document.body.classList.remove('excluding-list-open');
  };
  closeList.addEventListener('click', () => {
    closePopup();
  });
  openBtn.addEventListener('click', (e) => {
    e.preventDefault();
    openPopup();
  });
  savePopupBtn.addEventListener('click', () => {
    const savedInfo = document.querySelector('.saved__info');

    if (lastOrder) {
      dataToOrder = dataToOrder.filter((item) => item != lastOrder);
      dataToShow = dataToShow.filter((item) => item != lastOrder);
    }
    if (lastClubs) {
      dataToOrder = dataToOrder.filter((item) => item != lastClubs);
      dataToShow = dataToShow.filter((item) => item != lastClubs);
    }

    const newClub = avoidClubs.value.trim();
    const newOrder = avoidOrders.value == '' ? '' : 'MS' + avoidOrders.value.trim();
    if (newClub) {
      dataToOrder.push(newClub);
      dataToShow.push(newClub);
    }
    if (newOrder) {
      dataToOrder.push(newOrder);
      dataToShow.push(newOrder);
    }

    lastClubs = newClub;
    lastOrder = newOrder;
    refreshData();

    const newSavedInfo = addLines(dataToShow);
    savedInfo?.replaceWith(newSavedInfo);
    const btns = newSavedInfo?.querySelectorAll('.saved__info-btn');
    btns?.forEach((btn) => {
      btn.addEventListener('click', lineRemove);
    });

    closePopup();
  });

  function lineRemove(event) {
    const line = event?.target.closest('.saved__info-line');
    const text = line.querySelector('.saved__info-text').textContent;
    if (line) line.remove();
    dataToOrder = dataToOrder.filter((item) => item != text);
    dataToShow = dataToShow.filter((item) => item != text);
    document.getElementById(text).checked = false;
    refreshData();
    let check = checkList();
    if (check == 3) {
      disableList();
    } else {
      enableList();
    }
  }

  function refreshData() {
    let data = '';
    dataToOrder.forEach((str) => {
      if (str != '' && str != null) {
        data += '-' + str + '\n';
      }
    });
    dataToOrderEl.value = data.toLocaleUpperCase();
    dataToOrderEl.dispatchEvent(new Event('change'));
    document.dispatchEvent(new CustomEvent('bad-teams-updated'));
  }
  function addLines(arr) {
    let result = document.createElement('div');
    result.classList.add('saved__info');
    arr.forEach((el) => {
      if (el != '') {
        let line = document.createElement('div');
        line.classList.add('saved__info-line');
        let btn = document.createElement('button');
        btn.setAttribute('type', 'button');
        btn.classList.add('saved__info-btn');
        let text = document.createElement('span');
        text.classList.add('saved__info-text');
        text.textContent = el;
        btn.textContent = 'X';
        line.appendChild(btn);
        line.appendChild(text);
        result.appendChild(line);
      }
    });
    return result;
  }
  overlay.addEventListener('click', closePopup);
  document.addEventListener('change', (event) => {
    const targetInput = event.target.closest('input[name="bad_team"]');
    if (!targetInput) return;
    if (targetInput.checked) {
      dataToOrder.push(targetInput.value);
      dataToShow.push(targetInput.dataset.description);
    } else {
      dataToOrder = dataToOrder.filter((item) => item != targetInput.value);
      dataToShow = dataToShow.filter((item) => item != targetInput.dataset.description);
    }
    let check = checkList();
    if (check == 3) {
      disableList();
      refreshData();
    } else {
      enableList();
      refreshData();
    }
  });

  function checkList() {
    let count = 0;
    excludeListInputs.forEach((input) => {
      if (input.checked) {
        count++;
      }
    });
    return count;
  }
  function disableList() {
    excludeListInputs.forEach((input) => {
      if (!input.checked) input.setAttribute('disabled', 'true');
    });
  }
  function enableList() {
    excludeListInputs.forEach((input) => {
      input.removeAttribute('disabled');
    });
  }
});

window.addEventListener('kaching-bundles-initialized', () => {
  const sourceInput = document.getElementById('bad_teams');
  const targetInput = document.querySelector('#kaching-inputs input');

  if (!targetInput) return;

  targetInput.setAttribute('name', 'properties[_Bad_Teams]');

  const syncInput = (bundleEl) => {
    const items = typeof bundleEl.items === 'function' ? bundleEl.items() : [];
    const hasMultipleItems = items.length > 1;
    const propertyValue = sourceInput?.value ?? '';

    if (hasMultipleItems && propertyValue) {
      targetInput.disabled = false;
      targetInput.value = propertyValue;
      targetInput.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    targetInput.value = '';
    targetInput.disabled = true;
    targetInput.dispatchEvent(new Event('change', { bubbles: true }));
  };

  document.querySelectorAll('kaching-bundles-block').forEach((bundleEl) => {
    syncInput(bundleEl);

    bundleEl.addEventListener('items-changed', () => {
      syncInput(bundleEl);
    });
  });

  if (sourceInput) {
    sourceInput.addEventListener('change', () => {
      document.querySelectorAll('kaching-bundles-block').forEach(syncInput);
    });
  }
  if (typeof syncAllBundles == "function") {
      document.addEventListener('bad-teams-updated', syncAllBundles);
  }
});
